import { useState, forwardRef } from "react";
import { Input } from "./ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input field with a built-in show/hide toggle (eye icon).
 *
 * - Cooperates with the browser's native autocomplete : pass autoComplete="current-password"
 *   for login forms, and "new-password" for registration forms.
 * - Forwards refs and any extra props to the underlying <Input>.
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", "data-testid": testId = "password-input", ...rest },
  ref,
) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? "text" : "password"}
        className={`pr-11 ${className}`}
        data-testid={testId}
        {...rest}
      />
      <button
        type="button"
        tabIndex={-1}
        aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        aria-pressed={visible}
        onClick={() => setVisible((v) => !v)}
        className="absolute inset-y-0 right-0 px-3 flex items-center text-subtle hover:text-ink"
        data-testid={`${testId}-toggle`}
      >
        {visible ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
});

export default PasswordInput;
